/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_about_cat_f1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy — the Apex Team optimizer, Budget Boost price predictions, standings, statistics and fantasy points for every race since 2023.`)
};

const es_about_cat_f1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy — el optimizador Apex Team, predicciones de precios de Budget Boost, clasificaciones, estadísticas y puntos fantasy de cada carrera desde 2023.`)
};

const de_about_cat_f1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy — der Apex-Team-Optimizer, Budget-Boost-Preisprognosen, Tabellenstände, Statistiken und Fantasy-Punkte für jedes Rennen seit 2023.`)
};

const nl_about_cat_f1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy — de Apex Team-optimizer, Budget Boost-prijsvoorspellingen, standen, statistieken en fantasy-punten voor elke race sinds 2023.`)
};

const fr_about_cat_f1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy — l’optimiseur Apex Team, les prédictions de prix Budget Boost, les classements, les statistiques et les points fantasy pour chaque course depuis 2023.`)
};

const it_about_cat_f1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy — l’ottimizzatore Apex Team, le previsioni di prezzo di Budget Boost, classifiche, statistiche e punti fantasy per ogni gara dal 2023.`)
};

const pt_br2_about_cat_f1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy — o otimizador Apex Team, previsões de preço do Budget Boost, classificações, estatísticas e pontos fantasy de cada corrida desde 2023.`)
};

const pt_about_cat_f1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy — o otimizador Apex Team, previsões de preço do Budget Boost, classificações, estatísticas e pontos fantasy de cada corrida desde 2023.`)
};

const ja_about_cat_f1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1ファンタジー — Apexチームオプティマイザー、バジェットブーストの価格予測、順位表、統計、2023年以降の全レースのファンタジーポイント。`)
};

const zh_about_cat_f1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy — Apex Team 优化器、Budget Boost 价格预测、积分榜、统计数据，以及自 2023 年以来每场比赛的梦幻积分。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const about_cat_f1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.about_cat_f1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("about_cat_f1", locale)
	if (locale === "en") return en_about_cat_f1(inputs)
	if (locale === "es") return es_about_cat_f1(inputs)
	if (locale === "de") return de_about_cat_f1(inputs)
	if (locale === "nl") return nl_about_cat_f1(inputs)
	if (locale === "fr") return fr_about_cat_f1(inputs)
	if (locale === "it") return it_about_cat_f1(inputs)
	if (locale === "pt-BR") return pt_br2_about_cat_f1(inputs)
	if (locale === "pt") return pt_about_cat_f1(inputs)
	if (locale === "ja") return ja_about_cat_f1(inputs)
	return zh_about_cat_f1(inputs)
};